export enum ChipBGEnum {
  Dark = 'Dark',
  Light = 'Light',
}

export type ChipBGType = keyof typeof ChipBGEnum;
